// src/analytics/ga4.js
export function sendPageview(path) {
  // オフラインや gtag 未読み込み時は何もしない
  if (typeof navigator !== 'undefined' && !navigator.onLine) return;
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  window.gtag?.('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  });
}

export function sendEvent(name, params = {}) {
  window.gtag?.('event', name, params);
}
